export default [
  { header: 'ФНФ Лига', resource: 'fnf-league', action: 'view' },
  {
    title: 'Игры',
    route: 'fnf-league-games',
    icon: 'AwardIcon',
    resource: 'fnf-league',
    action: 'view',
  },
  {
    title: 'Расписание',
    route: 'fnf-league-schedule',
    icon: 'CalendarIcon',
    resource: 'fnf-league',
    action: 'view',
  },
  {
    title: 'Таблицы',
    route: 'fnf-league-tables',
    icon: 'BarChart2Icon',
    resource: 'fnf-league',
    action: 'view',
  },
]
